<template>
  <div id="settingsHotel">
    <Tabs>

      <TabSection :title="$t('settings.rooms')" v-if="config.hotel">
        <TipBox info :title="$t('tips.rooms.title')">
          <span v-html="$t('tips.rooms.description')"></span>
        </TipBox>
        <div class="group">
          <label>{{ $t("settings.rooms_list") }}</label>
          <VueSelect ref="select" multiple v-model="config.hotel.rooms" taggable :closeOnSelect="false">
            <span slot="no-options">{{ $t("settings.rooms_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <TabSection :title="$t('qr_payment.qr_code.title')" v-if="!!$route.query.company">
        <QrCodeGenerator :url="frontendUrl + '?method=hotel'" :urls="roomUrls"
          :description="$t('qr_payment.qr_code.in_place_description')"></QrCodeGenerator>
      </TabSection>

      <TabSection :title="$t('settings.general')" v-if="config.hotel" class="general">
        <div class="columns">
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.delay") }}</label>
              <input type="number" v-model="config.hotel.general.averageDelay">
            </div>
            <div class="group" v-if="permissions.tipsActivated">
              <div class="subtitle">{{ $t('settings.tip') }}</div>
              <TipBox no-border info>
                <span v-html="$t('tips.tip')"></span>
              </TipBox>
              <label>{{ $t("settings.tip") }}</label>
              <select v-model="config.hotel.general.tipsActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>

            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.service_fee") }}</span>
            </div>
            <TipBox info no-border>
              <span v-html="$t('tips.service_fees')"></span>
            </TipBox>
            <div class="group">
              <label>{{ $t("settings.amount") }} ({{ currencySymbol }})</label>
              <input type="number" v-model="config.hotel.general.serviceFees.amount">
            </div>
          </div>
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.order_amount") }}</span>
            </div>
            <TipBox danger no-border>
              <span v-html="$t('tips.minimum_amount')"></span>
            </TipBox>
            <div class="columns">
              <div class="column group">
                <label>{{ $t("settings.minimum_amount") }} ({{ currencySymbol }})</label>
                <input type="number" v-model="config.hotel.general.minimumPrice">
              </div>
              <!--<div class="column group">
                <label>{{$t("settings.maximum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.hotel.general.maximumPrice">
              </div>-->
            </div>
            <!--
            <div class="subtitle">
              <span class="flex-grow">{{$t("settings.order_clients")}}</span>
            </div>
            <div class="columns">
              <div class="column group">
                <label>{{$t("settings.minimum_clients")}}</label>
                <input type="number" v-model="config.hotel.general.minimumMeals">
              </div>
              <div class="column group">
                <label>{{$t("settings.maximum_clients")}}</label>
                <input type="number" v-model="config.hotel.general.maximumMeals">
              </div>
            </div>
            -->
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('open_hours')" v-if="cascader && config.hotel">
        <TipsOpenHours />
        <div id="editOpenHoursContainerHotel" class="group">
          <input id="editOpenHoursHotel" type="checkbox" v-model="config.hotel.editOpenHours">
          <label for="editOpenHoursHotel">{{ $t("settings.edit_open_hours") }}</label>
        </div>
        <div class="columns" :class="{ openHoursDisabled: !config.hotel.editOpenHours }">
          <div class="column">
            <DayTimeRange :day="cascader.get('hotel.hours.monday').value" dayName="monday" context="hotel"
              errorsKey="config.hotel.hours.monday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('hotel.hours.tuesday').value" dayName="tuesday" context="hotel"
              errorsKey="config.hotel.hours.tuesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('hotel.hours.wednesday').value" dayName="wednesday" context="hotel"
              errorsKey="config.hotel.hours.wednesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('hotel.hours.thursday').value" dayName="thursday" context="hotel"
              errorsKey="config.hotel.hours.thursday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
          <div class="column">
            <DayTimeRange :day="cascader.get('hotel.hours.friday').value" dayName="friday" context="hotel"
              errorsKey="config.hotel.hours.friday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('hotel.hours.saturday').value" dayName="saturday" context="hotel"
              errorsKey="config.hotel.hours.saturday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('hotel.hours.sunday').value" dayName="sunday" context="hotel"
              errorsKey="config.hotel.hours.sunday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('message')" v-if="config.hotel">
        <TipBox info>
          <span v-html="$t('tips.message.hotel')"></span>
        </TipBox>
        <div class="group">
          <LocalizedInput textarea :title="$t('settings.service_message')"
            :translate="config.hotel.onEnterMessage.message" />
        </div>
        <div class="group">
          <input id="chkPopupHotel" type="checkbox" v-model="config.hotel.onEnterMessage.type" true-value="popup"
            :false-value="null">
          <label for="chkPopupHotel">{{ $t('settings.open_in_window') }}</label>
        </div>
      </TabSection>

      <TabSection :title="$t('notifications')" v-if="config.hotel">
        <TipsNotification />
        <div class="subtitle">
          <span class="flex-grow">{{ $t("settings.on_sale_notification") }}</span>
        </div>
        <TipBox warning v-if="!isSMSactivated" no-border>
          <div v-html="$t('tips.sms_feature.disabled')"></div>
        </TipBox>
        <div class="group" :class="{ locked: !isSMSactivated }">
          <label>{{ $t("settings.sms_notification") }}</label>
          <VueSelect multiple v-model="config.hotel.notifications.onSale.sms" taggable>
            <span slot="no-options">{{ $t("settings.sms_tip") }}</span>
          </VueSelect>
        </div>
        <div class="group">
          <label>{{ $t("settings.email_notification") }}</label>
          <VueSelect multiple v-model="config.hotel.notifications.onSale.emails" taggable>
            <span slot="no-options">{{ $t("settings.email_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.order_in_advance')" v-if="config.hotel">
        <TipsInAdvance />
        <div id="activateInAdvanceContainerHotel" class="group">
          <input id="activateInAdvanceHotel" type="checkbox" v-model="config.hotel.inAdvance.activated">
          <label for="activateInAdvanceHotel">{{ $t("settings.activate_order_in_advance") }}</label>
        </div>
        <div class="columns" v-if="config.hotel.inAdvance.activated">
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.asap") }}</label>
              <select v-model="config.hotel.inAdvance.ASAP">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" v-if="$store.state.loggedUser.isSuperAdmin">
              <label>{{ $t('settings.future_dates') }}</label>
              <select v-model="config.hotel.inAdvance.futureDate">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <!--
            <div class="group">
              <label>{{$t("settings.outside_open_hours")}}</label>
              <select v-model="config.hotel.inAdvance.outsideHours">
                <option :value="true" selected>{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div> -->
          </div>
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.interval") }}</label>
              <select v-model="config.hotel.inAdvance.intervalInMinutes">
                <option :value="minute" v-for="minute of [5, 10, 15, 20, 30, 45, 60]">{{ minute }}</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t("settings.orders_per_interval") }}</label>
              <input type="number" v-model="config.hotel.inAdvance.maxPerInterval">
            </div>
          </div>
        </div>
      </TabSection>

    </Tabs>

    <div class="footer-actions">
      <button class="btn btn-primary" @click="$emit('save')">{{ $t("save") }}</button>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import Cascader from "@/resources/cascader";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import VueSelect from 'vue-select';
  import TipsNotification from "@/components/tips/TipsNotification.vue";
  import TipsOpenHours from "@/components/tips/TipsOpenHours.vue";
  import QrCodeGenerator from "@/components/QrCodeGenerator.vue";
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import TipsInAdvance from "@/components/tips/TipsInAdvance.vue";

  export default {

    name: "SettingsHotel",

    props: {
      config: Object,
      parentConfig: Object,
      permissions: Object,
      parentValidate: Object,
      currencySymbol: {
        type: String,
        default: '$'
      }
    },

    components: { VueSelect, DayTimeRange, TipsOpenHours, TipsNotification, QrCodeGenerator, LocalizedInput, TipsInAdvance },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);

      let urlFrontend = this.$store.state.contextServer.urlFrontend;
      let company = await this.$store.getters.getContextCompany;
      let branch = await this.$store.getters.getContextBranch;
      this.frontendUrl = urlFrontend + "/#/" + branch.nameCanonical + "/" + company.nameCanonical + "/menu";
    },

    computed: {
      isSMSactivated() {
        return this.$store.state.contextCompany && this.$store.state.contextCompany.smsActivated;
      },
      roomUrls() {
        return this.config.hotel.rooms.map(room => {
          return {
            filename: 'room-' + room,
            url: this.frontendUrl + "?room=" + room
          }
        });
      }
    },

    data() {
      return {
        cascader: null,
        frontendUrl: null
      }
    },

    watch: {
      "config.hotel.editOpenHours": function (edit, old) {
        if (old === undefined) {
          return;
        }
        if (edit) {
          Vue.set(this.config.hotel, "hours", this._copy(this.parentConfig.hotel.hours));
        } else {
          Vue.delete(this.config.hotel, "hours");
        }
        this.$forceUpdate();
      }
    },

    methods: {
      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      }
    }
  }
</script>

<style lang="scss" scoped>
  #settingsHotel {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .general {
    .subtitle {
      padding-top: 10px;
    }
  }

  #editOpenHoursContainerHotel,
  #activateInAdvanceContainerHotel {
    label {
      color: #404040;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .openHoursDisabled {
    opacity: 0.7;
    pointer-events: none;
  }

  input {
    width: 100%;
  }
</style>